export const createBackofficeFieldDecorators = (
  redactedFields: string[],
  isBackoffice = false,
) => {
  const isRedactedId = (id: string) => redactedFields.includes(id);
  const decorateTitle = (id: string, title: string = "") =>
    isBackoffice && isRedactedId(id) ? `${title} (HIDDEN)` : title;
  const getRedactedClassName = (id: string) =>
    isBackoffice && isRedactedId(id)
      ? { className: "bg-red-100" }
      : { className: "" };
  return {
    decorateTitle,
    getRedactedClassName,
    hiddenColumns: isBackoffice ? [] : redactedFields,
  };
};
